export default "__VITE_ASSET__6f142380__"